import GetItems from "../../components/getItems";
import Header from "../../components/Header";


export default function TodosPaises(){
    return(
       <>
         <Header/>
         <GetItems/>
       </>
    )
}